import type { CallbackEntry, CallLogEntry } from '../types';
import { useState } from 'react';
import { Modal } from './Modal';

const when = (ms: number | null) => (ms ? new Date(ms).toLocaleString() : '—');

export function CallbacksList({ items, onClose }: { items: CallbackEntry[]; onClose: () => void }) {
  return (
    <Modal id="CalLBacKsLisTBox" title="Callbacks" onClose={onClose}>
      <table className="list"><thead><tr><th>Due</th><th>Name</th><th>Phone</th><th>Owner</th></tr></thead><tbody>
        {items.length === 0 && <tr><td colSpan={4} style={{ color: 'var(--muted)' }}>No scheduled callbacks</td></tr>}
        {items.map((c) => <tr key={c.lead_id}><td>{when(c.due_at)}</td><td>{[c.data['first_name'], c.data['last_name']].filter(Boolean).join(' ')}</td><td>{c.phone_number}</td><td>{c.agent_id ?? 'Anyone'}</td></tr>)}
      </tbody></table>
      <div className="actions"><button onClick={onClose}>Close</button></div>
    </Modal>
  );
}

export function CallLog({ items, onClose }: { items: CallLogEntry[]; onClose: () => void }) {
  return (
    <Modal id="CalLLoGDisplaYBox" title="Call Log (this session)" onClose={onClose}>
      <table className="list"><thead><tr><th>Started</th><th>Phone</th><th>Lead</th><th>Duration</th><th>Disposition</th></tr></thead><tbody>
        {items.length === 0 && <tr><td colSpan={5} style={{ color: 'var(--muted)' }}>No calls yet</td></tr>}
        {items.map((c) => <tr key={c.outbound_call_id}><td>{when(c.started_at)}</td><td>{c.phone_number ?? '—'}</td><td>{c.lead_id}</td><td>{c.ended_at ? `${Math.round((c.ended_at - c.started_at) / 1000)}s` : '—'}</td><td>{c.disposition ?? '—'}</td></tr>)}
      </tbody></table>
      <div className="actions"><button onClick={onClose}>Close</button></div>
    </Modal>
  );
}

export function PauseCodePicker({ codes, onPick, onClose }: { codes: Array<{ code: string; name: string }>; onPick: (code: string) => void; onClose: () => void }) {
  return (
    <Modal id="PauseCodeSelectBox" title="Pause Code" onClose={onClose}>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
        {codes.map((c) => <button key={c.code} onClick={() => onPick(c.code)}>{c.name} <span style={{ color: 'var(--muted)' }}>({c.code})</span></button>)}
      </div>
      <div className="actions"><button onClick={onClose}>Cancel</button></div>
    </Modal>
  );
}

export function TransferPanel({ agents, onTransfer, onExternal, onThreeWay, onThreeWayAgent, onClose }: {
  agents: Array<{ agent_id: string; state: string }>;
  onTransfer: (id: string) => void;
  onExternal: (number: string) => void;
  onThreeWay: (number: string) => void;
  onThreeWayAgent?: (id: string) => void;
  onClose: () => void;
}) {
  const [num, setNum] = useState('');
  const valid = /^\+?[0-9][0-9\s()-]{6,}$/.test(num);
  return (
    <Modal id="TransferMain" title="Transfer" onClose={onClose}>
      <table className="list"><thead><tr><th>Agent</th><th>State</th><th></th></tr></thead><tbody>
        {agents.length === 0 && <tr><td colSpan={3} style={{ color: 'var(--muted)' }}>No other agents logged in</td></tr>}
        {agents.map((a) => <tr key={a.agent_id}><td>{a.agent_id}</td><td>{a.state}</td><td><button className="primary" disabled={a.state !== 'ready'} onClick={() => onTransfer(a.agent_id)}>Transfer</button>{onThreeWayAgent && <button disabled={a.state !== 'ready'} onClick={() => onThreeWayAgent(a.agent_id)}>3-way</button>}</td></tr>)}
      </tbody></table>
      <div style={{ marginTop: 12 }}>
        <label>Transfer to number</label>
        <input id="xfernumber" value={num} onChange={(e) => setNum(e.target.value)} placeholder="+1 207 555 0123" />
        <div style={{ display: 'flex', gap: 8, marginTop: 6 }}>
          <button id="xfer-blind" className="primary" disabled={!valid} onClick={() => onExternal(num.replace(/[^0-9+*#]/g, ''))}>Blind transfer</button>
          <button id="xfer-3way" disabled={!valid} onClick={() => onThreeWay(num.replace(/[^0-9+*#]/g, ''))}>3-way</button>
        </div>
      </div>
      <div className="actions"><button onClick={onClose}>Close</button></div>
    </Modal>
  );
}

export function WrapupBox({ seconds, onSkip }: { seconds: number; onSkip: () => void }) {
  return (
    <Modal id="WrapupBox" title="Wrap-up">
      <div className="count">{seconds}</div>
      <div style={{ color: 'var(--muted)' }}>Next call in… </div>
      <div className="actions"><button className="primary" onClick={onSkip}>Ready now</button></div>
    </Modal>
  );
}
